<template>
  <Modal v-model="modal" title="身份验证信息" footer-hide>
    <verification ref="verification" @changeverificationoStatus="verificationoOver = true" v-if="!verificationoOver && modal" />
    <div class="real-info" v-if="verificationoOver">
      <p>
        <b>{{contact}}</b>
        <span class="mgl12" v-if="passCode === 2">已实名</span>
      </p>
      <p>证件类型：身份证</p>
      <p>
        <span>证件号码：{{idCardShow ? idCard : accountInfo.cardNO}}</span>
        <Icon :type="idCardShow ? 'md-eye' : 'md-eye-off'" @click="idCardShow = !idCardShow" class="mgl12" />
      </p>
      <img :src="accountInfo.cardNoFront" class="mgl12" @click="viewImgSrc = accountInfo.cardNoFront">
      <img :src="accountInfo.cardNoReverse" @click="viewImgSrc = accountInfo.cardNoReverse">
      <p>银行卡：{{accountInfo.dueBank}}
        <span class="mgl12">{{bankCardShow ? bankCard : accountInfo.bankCard}}</span>
        <Icon :type="bankCardShow ? 'md-eye' : 'md-eye-off'" @click="bankCardShow = !bankCardShow" class="mgl12" />
      </p>
    </div>
    <viewBigImg  :imgSrc="viewImgSrc" @close="viewImgSrc = ''"  />
  </Modal>
</template>

<script>
import viewBigImg from "@/components/viewBigImg/index"
import verification from "./verification"
export default {
  name: "RealInfoSee",
  components: {
    viewBigImg,
    verification
  },
  props: {
    passCode: {
      type: Number,
      default: 0
    },
    contact: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modal: false,
      accountInfo: {},
      idCard: "",
      idCardShow: false,
      bankCard: "",
      bankCardShow: false,
      viewImgSrc: "",
      verificationoOver: false
    }
  },
  watch: {
    modal(v) {
      if (v) {
        this.verificationoOver = false
      }
    },
    verificationoOver(v) {
      if (v) {
        this.LookUnionUserInfo()
        this.LookCardNo()
        this.LookBankCard()
      } 
    }
  },
  methods: {
    LookUnionUserInfo() {
      if (Object.keys(this.accountInfo).length > 0) { return }
      this.$store.dispatch('account/LookUnionUserInfo').then(({ list }) => {
        this.accountInfo = list
      }).catch(({ msg })  => {
        this.$Message.error(msg)
      })
    },
    LookCardNo() {
      if (this.idCard) { return }
      this.$store.dispatch('account/LookCardNo').then(({ list }) => {
        this.idCard = list
      }).catch(({ msg })  => {
        this.$Message.error(msg)
      })
    },
    LookBankCard() {
      if (this.bankCard) { return }
      this.$store.dispatch('account/LookBankCard').then(({ list }) => {
        this.bankCard = list
      }).catch(({ msg })  => {
        this.$Message.error(msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin-bottom: 12px;
  .ivu-icon{
    font-size: 20px;
    cursor: pointer;
  }
  .mgl12{
    margin-left: 12px;
  }
}
img{
  width: 180px;
  margin-left: 10px;
  cursor: pointer;
}
</style>